export default __webpack_public_path__ + "static/monthly-offer-a146efd342e909161e78bcee9396a9f8.png";